var dom_cursor_controller = (function () {
	var hasInitialized = false
	var initRetryCount = 0
	var initRetryTimer = null

	var stateMap = {
		root: null,
		img: null,
		contexts: {},
		updateCounter: 0,
		lastPointer: {
			x: null,
			y: null,
		},
		customizerConfig: null,
	}

	var normalizeNumber = function (value) {
		var parsed = parseFloat(value)
		return isNaN(parsed) ? 0 : parsed
	}

	var getTopContext = function () {
		var activeContexts = Object.keys(stateMap.contexts)
			.map(function (key) {
				return stateMap.contexts[key]
			})
			.filter(function (context) {
				return context && context.visible && context.src
			})
			.sort(function (a, b) {
				if ((a.priority || 0) !== (b.priority || 0)) {
					return (b.priority || 0) - (a.priority || 0)
				}
				return (b.updatedAt || 0) - (a.updatedAt || 0)
			})

		return activeContexts.length ? activeContexts[0] : null
	}

	var render = function () {
		if (!stateMap.root || !stateMap.img) {
			return
		}

		var context = getTopContext()
		if (!context) {
			stateMap.root.style.display = 'none'
			stateMap.root.style.transform = 'translate3d(-9999px,-9999px,0)'
			return
		}

		if (stateMap.img.getAttribute('src') !== context.src) {
			stateMap.img.setAttribute('src', context.src)
		}
		stateMap.img.style.width = context.width ? normalizeNumber(context.width) + 'px' : 'auto'
		stateMap.img.style.height = context.height ? normalizeNumber(context.height) + 'px' : 'auto'

		stateMap.root.style.display = 'block'
		stateMap.root.style.transform =
			'translate3d(' +
			(normalizeNumber(context.x) - normalizeNumber(context.hotspotX)) +
			'px,' +
			(normalizeNumber(context.y) - normalizeNumber(context.hotspotY)) +
			'px,0)'
	}

	var setContext = function (owner, data) {
		if (!owner || !data) {
			return
		}
		stateMap.contexts[owner] = Object.assign({}, stateMap.contexts[owner] || {}, data, {
			owner: owner,
			visible: data.visible !== false,
			updatedAt: ++stateMap.updateCounter,
		})
		render()
	}

	var hideContext = function (owner) {
		if (!stateMap.contexts[owner]) {
			return
		}
		stateMap.contexts[owner].visible = false
		stateMap.contexts[owner].updatedAt = ++stateMap.updateCounter
		render()
	}

	var removeContext = function (owner) {
		if (!stateMap.contexts[owner]) {
			return
		}
		delete stateMap.contexts[owner]
		render()
	}

	var hideAllContexts = function () {
		Object.keys(stateMap.contexts).forEach(function (key) {
			stateMap.contexts[key].visible = false
			stateMap.contexts[key].updatedAt = ++stateMap.updateCounter
		})
		stateMap.lastPointer.x = null
		stateMap.lastPointer.y = null
		render()
	}

	var setCustomizerClassEnabled = function (enabled, isLinkCursor) {
		if (enabled) {
			document.documentElement.classList.add('lay-dom-cursor-customizer')
		} else {
			document.documentElement.classList.remove('lay-dom-cursor-customizer')
		}
		document.documentElement.classList.toggle('lay-dom-cursor-customizer-link', !!(enabled && isLinkCursor))
	}

	var getSiteCursorConfig = function (config) {
		if (!config) {
			return null
		}
		if (config.siteCursor && config.siteCursor.src) {
			return config.siteCursor
		}
		// Keep the controller compatible with pages that still contain cached
		// pre-link-cursor layData using the former flat config shape.
		if (config.src) {
			return {
				src: config.src,
				hotspotX: config.hotspotX,
				hotspotY: config.hotspotY,
				width: config.width,
				height: config.height,
			}
		}
		return null
	}

	var resolveCursorPolicy = function (elAtPoint) {
		var config = stateMap.customizerConfig
		var isCustomizerActive = !!(config && config.active === true)
		if (!isCustomizerActive) {
			return { mode: 'none' }
		}

		var hasClosest = !!(elAtPoint && elAtPoint.closest)
		var isLinkTarget = !!(hasClosest && elAtPoint.closest('a'))
		var linkCursor = config.linkCursor && config.linkCursor.src ? config.linkCursor : null
		var siteCursor = getSiteCursorConfig(config)

		// A dedicated link cursor wins over the global site cursor and over
		// specialized addon cursor areas, but only on actual anchors.
		if (isLinkTarget && linkCursor) {
			return { mode: 'customizer-dom', asset: linkCursor, isLinkCursor: true }
		}

		var isNativeFullscreenSliderCursorArea = hasClosest && elAtPoint.closest('.grid.up, .grid.down, .grid.left, .grid.right')
		var isNativeCarouselCursorArea = hasClosest && elAtPoint.closest('.lay-carousel.cursor-left, .lay-carousel.cursor-right')
		var isNativeLightboxCursorArea = hasClosest && elAtPoint.closest('#lightbox-inner.cursor-left, #lightbox-inner.cursor-right')

		if (isNativeFullscreenSliderCursorArea || isNativeCarouselCursorArea || isNativeLightboxCursorArea) {
			return { mode: 'native-specialized' }
		}

		var shouldUseNativeLinkCursor = !!(config.keepNormalCursorForLinks && isLinkTarget)
		if (shouldUseNativeLinkCursor) {
			return { mode: 'native-link' }
		}

		if (siteCursor) {
			return { mode: 'customizer-dom', asset: siteCursor, isLinkCursor: false }
		}

		return { mode: 'native-default' }
	}

	var updateCustomizerCursor = function (clientX, clientY) {
		var config = stateMap.customizerConfig
		if (!config || config.active !== true) {
			return
		}

		var elAtPoint = document.elementFromPoint(clientX, clientY)
		var policy = resolveCursorPolicy(elAtPoint)

		if (policy.mode !== 'customizer-dom') {
			setCustomizerClassEnabled(false, false)
			hideContext('customizer')
			return
		}

		setCustomizerClassEnabled(true, policy.isLinkCursor)

		setContext('customizer', {
			priority: 10,
			src: policy.asset.src,
			hotspotX: policy.asset.hotspotX,
			hotspotY: policy.asset.hotspotY,
			width: policy.asset.width,
			height: policy.asset.height,
			x: clientX,
			y: clientY,
		})
	}

	var bindCustomizerTracking = function () {
		// Cursor updates are throttled to one per animation frame.
		// Without this, every mousemove (up to 1000Hz on high-polling mice) and
		// every scroll tick during a smooth scroll calls updateCustomizerCursor,
		// which does a synchronous elementFromPoint (forces layout) plus inline
		// style writes. That layout-thrash competed with the magneticslides addon
		// in both modes — the fullpage.js transform animation and the CSS
		// scroll-snap smooth-scroll — and produced visible cursor stutter.
		var pendingFrame = false
		var scheduleUpdate = function () {
			if (pendingFrame) {
				return
			}
			pendingFrame = true
			window.requestAnimationFrame(function () {
				pendingFrame = false
				if (stateMap.lastPointer.x === null || stateMap.lastPointer.y === null) {
					return
				}
				updateCustomizerCursor(stateMap.lastPointer.x, stateMap.lastPointer.y)
			})
		}

		document.addEventListener(
			'mousemove',
			function (event) {
				stateMap.lastPointer.x = event.clientX
				stateMap.lastPointer.y = event.clientY
				scheduleUpdate()
			},
			{ passive: true }
		)

		document.addEventListener('mouseout', function (event) {
			if (event.relatedTarget || event.toElement) {
				return
			}
			hideAllContexts()
		})

		window.addEventListener('scroll', scheduleUpdate, { passive: true })
		window.addEventListener('resize', scheduleUpdate)

		window.addEventListener('blur', function () {
			hideAllContexts()
		})
	}

	var exposeApi = function () {
		window.layDomCursor = {
			setContext: setContext,
			hideContext: hideContext,
			removeContext: removeContext,
			hideAllContexts: hideAllContexts,
			getLastPointer: function () {
				return {
					x: stateMap.lastPointer.x,
					y: stateMap.lastPointer.y,
				}
			},
			render: render,
		}
	}

	var init = function () {
		if (hasInitialized) {
			return
		}

		stateMap.root = document.getElementById('lay-dom-cursor')
		if (!stateMap.root) {
			if (initRetryCount < 20 && !initRetryTimer) {
				initRetryCount++
				initRetryTimer = window.setTimeout(function () {
					initRetryTimer = null
					init()
				}, 50)
			}
			if (document.readyState === 'loading') {
				document.addEventListener('DOMContentLoaded', init, { once: true })
			}
			return
		}
		hasInitialized = true
		if (initRetryTimer) {
			window.clearTimeout(initRetryTimer)
			initRetryTimer = null
		}

		stateMap.img = stateMap.root.querySelector('img')
		stateMap.customizerConfig = layData.dom_cursor_customizer || null

		exposeApi()
		window.dispatchEvent(new Event('layDomCursorReady'))

		if (stateMap.customizerConfig && stateMap.customizerConfig.active === true && getSiteCursorConfig(stateMap.customizerConfig)) {
			setCustomizerClassEnabled(true, false)
		}

		bindCustomizerTracking()
		bindNavigationReset()
		render()
	}

	// Hide all contexts on AJAX navigation. Owner modules (magneticslides
	// up/down arrows, carousel left/right cursors, lightbox cursors, etc.)
	// register their contexts on hover but don't proactively unregister when
	// a navigation removes their region from the DOM. Without this, a user
	// who hovered an FS-slider arrow and then navigated back to a regular
	// page would see the arrow cursor stuck on the new page until they
	// moved their mouse over an element that re-evaluates the cursor.
	//
	// hideAllContexts also clears lastPointer, so the customizer's
	// per-frame mousemove tracking re-evaluates from scratch on the next
	// mousemove instead of immediately re-rendering the customizer cursor
	// at the now-stale stored position.
	var bindNavigationReset = function () {
		if (!window.laytheme || typeof window.laytheme.on !== 'function') {
			return
		}
		window.laytheme.on('newpageshown', function () {
			hideAllContexts()
		})
	}

	return {
		i: init,
	}
})()

export default dom_cursor_controller
